var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktok1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6002 15.82C25.9167 15.0395 25.5401 14.0374 25.5402 13H22.4502V25.4C22.4268 26.0712 22.1437 26.7071 21.6605 27.1735C21.1773 27.6399 20.5318 27.9004 19.8602 27.9C18.4402 27.9 17.2602 26.74 17.2602 25.3C17.2602 23.58 18.9202 22.29 20.6302 22.82V19.66C17.1802 19.2 14.1602 21.88 14.1602 25.3C14.1602 28.63 16.9202 31 19.8502 31C22.9902 31 25.5402 28.45 25.5402 25.3V19.01C26.7932 19.9099 28.2975 20.3926 29.8402 20.39V17.3C29.8402 17.3 27.9602 17.39 26.6002 15.82Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok1);
export default __webpack_public_path__ + "static/media/tiktok1.c65e8b4f53aac1eaa28c24922d053f2e.svg";
export { ForwardRef as ReactComponent };